import * as React from 'react';

import styles from './ImageMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessage } from '../../../ChatMessage';
import { MetaRow } from '../MetaRow';

interface IImageMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  imageMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  replyQuote: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const ImageMessageLayout = React.forwardRef<HTMLDivElement, IImageMessageLayoutProps>(
  function ImageMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      imageMessage,
      messageMeta,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText} className={styles['image-message__row']}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['image-message__bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['image-message__quote']}>{replyQuote}</div>
          {imageMessage}
          <MetaRow messageType={messageType} withBackground userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
